if (!customElements.get('avora-marquee')) {
  customElements.define('avora-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.viewport = this.querySelector('.avora-marquee__viewport');
      this.track = this.querySelector('.avora-marquee__track');
      this.group = this.querySelector('.avora-marquee__group');
      if (!this.viewport || !this.track || !this.group) return;
      this.initialized = true;
      this.resizeObserver = new ResizeObserver(() => this.scheduleRefresh());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.group);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.track.style.animationPlayState = entries[0]?.isIntersecting ? '' : 'paused';
      }, { rootMargin: '64px' });
      this.visibilityObserver.observe(this);
      document.fonts?.ready.then(() => this.isConnected && this.scheduleRefresh());
      this.scheduleRefresh();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.initialized = false;
    }

    scheduleRefresh() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (this.isConnected) this.refresh();
      });
    }

    refresh() {
      const distance = this.group.getBoundingClientRect().width;
      const viewportWidth = this.viewport.clientWidth;
      if (!distance || !viewportWidth) return;
      const copies = Math.max(1, Math.ceil(viewportWidth / distance));
      const existingCopies = [...this.track.querySelectorAll('[data-marquee-copy]')];
      existingCopies.slice(copies).forEach(copy => copy.remove());
      for (let index = existingCopies.length; index < copies; index += 1) {
        const copy = this.group.cloneNode(true);
        copy.setAttribute('data-marquee-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        this.track.append(copy);
      }
      const speed = Number(this.dataset.speed) || 38;
      if (this.distance !== distance || this.speed !== speed) {
        this.style.setProperty('--marquee-distance', `${distance}px`);
        this.style.setProperty('--marquee-duration', `${distance / speed}s`);
        this.distance = distance;
        this.speed = speed;
      }
      if (!this.hasAttribute('data-ready')) this.setAttribute('data-ready', '');
    }
  });
}
